/* eslint-disable no-restricted-imports */
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import {
	AccountSummaryOrdersLinkButtonSX,
	AccountSummaryTitleSX,
} from '@/components/content/Account/styles/summary';
import { OrderCard } from '../../OrderHistory/parts/History/parts/OrderCard';
import { MouseEvent } from 'react';
import { useOrderHistoryWithDetails } from '@/data/Content/OrderHistory';
import { ACCOUNT_TABS } from './Tabs';

type Orders = ReturnType<typeof useOrderHistoryWithDetails>['ordersWithItemsDetails'];

interface AccountSummaryOrdersProps {
	orders: Orders;
	mobile: boolean;
	onReOrder: (fromOrderId: string) => (_e: MouseEvent<HTMLButtonElement>) => Promise<void>;
	onSelectedTab: (tab: ACCOUNT_TABS) => void;
}

export const AccountSummaryOrders: React.FC<AccountSummaryOrdersProps> = ({
	orders,
	mobile,
	onReOrder,
	onSelectedTab,
}) => {
	const handleTabOrders = () => {
		onSelectedTab(ACCOUNT_TABS.ORDERS_HISTORY);
		scrollTo(0, 0);
	};

	return (
		<Box>
			<Typography sx={AccountSummaryTitleSX}>{'PEDIDOS RECIENTES'}</Typography>
			<Stack spacing={2}>
				<Stack spacing={2}>
					{orders.map((row) => (
						<OrderCard
							key={row.orderId}
							order={row}
							isMobile={mobile}
							onReOrder={onReOrder(row.orderId as string)}
						/>
					))}
				</Stack>
				<ButtonBase sx={AccountSummaryOrdersLinkButtonSX} disableRipple onClick={handleTabOrders}>
					{'Ver todos los pedidos'}
				</ButtonBase>
			</Stack>
		</Box>
	);
};
